import {
  Table, TableBody, TableCell,
} from '@mui/material';
import * as React from 'react';
import Box from '@mui/material/Box';
import { TableRow } from '../../common/Table';

type VideoPropertiesProps = {
  creatorName: string,
  creatorLogoUrl:string,
  creatorUrl:string,
  useOrgMetadata:boolean,
}


export const PanelVideoProperties = ({ creatorUrl, creatorLogoUrl, creatorName, useOrgMetadata }: VideoPropertiesProps) => {

  let logo = creatorLogoUrl;
  if (creatorLogoUrl.includes('amazonaws')) {
    const url = new URL(creatorLogoUrl);
    logo = `https://assets${process.env.REACT_APP_STAGE === 'prod' ? '' : '-dev'}.pixels.ai${url.pathname}`
  }

  console.log('logo', logo);
  return (
    <Box sx={{
      p: 2,
      // display: 'flex',
      width: '100%',
    }}>
      <Table>
          <TableBody>
            <TableRow>
              <TableCell component="th"
                         sx={{ fontWeight: 'bold', width: '200px' }}>Creator name</TableCell>
              <TableCell>{creatorName}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell component="th" sx={{ fontWeight: 'bold' }}>Creator URL</TableCell>
                <TableCell>{ creatorUrl }</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" sx={{ fontWeight: 'bold', width: '200px' }}>Creator Logo URL</TableCell>
                <TableCell><img width={50} alt="" src={logo} /></TableCell>
              </TableRow>
                <TableRow>
                  <TableCell component="th" sx={{ fontWeight: 'bold' }}>Use org metadata</TableCell>
                  <TableCell>{useOrgMetadata}</TableCell>
                </TableRow>
          </TableBody>
        </Table>
    </Box>

  );
};


